module.exports = __webpack_public_path__ + "img/top.d71ff78b.png";